import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import find from 'lodash.find'
import SocialShareButtons from '../components/SocialShareButtons'
import CaseStudyMetaContents from '../components/CaseStudyMetaContents'
import classnames from 'classnames'

import {
  getNormalisedPathname,
  generatePageDataFromPathname,
  getWpPostBySlug
} from '../../utils/wordpress'

import { IS_NODE, IS_PROD, IS_SANDBOX } from '../../config/'

import { requestWpCaseStudyPostDataSuccess } from '../../reducers/wpData'

const DESCRIPTION_MAX_LENGTH = 160

export const CaseStudyPage = class CaseStudyPage extends Component {
  constructor () {
    super()
    this.state = {}
  }
  componentDidUpdate (prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this._requestPageDataFromWpMaybe()
    }
  }
  componentWillMount () {
    this._requestPageDataFromWpMaybe()
  }
  _requestPageDataFromWpMaybe () {
    if (
      IS_NODE || // in SSR we already have the latest data prefetched
      !this.props.data ||
      !this.props.data.slug || // we need slug to be able to fetch from WP api
      // if we have heroTitle, then we have already got the data for this page
      // dont re-fetch if in prod
      (IS_PROD && !IS_SANDBOX && this.props.data.acf.heroTitle)
    ) {
      return
    }
    getWpPostBySlug(this.props.data.slug).then(
      this.props.requestWpCaseStudyPostDataSuccess
    )
  }
  render () {
    const {
      data: {
        acf: { heroBackground, heroTitle, headLine, subHeadLine, metaContent },
        // extract the rendered key from content object as content
        content: { rendered: content } = { rendered: '' },
        excerpt: { rendered: excerpt } = { rendered: '' },
        link
      }
    } = this.props

    // simple regex to strip out html tags
    let description = excerpt.replace(/<(?:.|\n)*?>/gm, '')
    if (description.length > DESCRIPTION_MAX_LENGTH) {
      description = description.slice(0, DESCRIPTION_MAX_LENGTH - 1) + '…'
    }
    const pageTitle = `${heroTitle} | Snips Case Study`
    let metaTagList = [
      { property: 'og:site_name', content: 'Snips' },
      { property: 'twitter:site', content: '@snips' },
      { property: 'twitter:creator', content: '@snips' },
      { property: 'og:title', content: pageTitle },
      { property: 'og:description', content: description },
      { property: 'description', content: description },
      { property: 'twitter:card', content: 'summary_large_image' }
    ]
    if (heroBackground) {
      metaTagList = metaTagList.concat([
        { property: 'og:image', content: heroBackground },
        // NOTE: would be much better if we could read these values from WP..
        { property: 'og:image:width', content: 1089 },
        { property: 'og:image:height', content: 817 }
      ])
    }
    return (
      <main className='main mx-auto case-study-page pb4'>
        {/* NOTE: Helmet lib content goes into <head> tags */}
        <Helmet title={pageTitle} meta={metaTagList} />
        <header className='case-study-page__header relative'>
          <div
            className='case-study-page__cover-img absolute top-0 left-0 right-0 bottom-0'
            style={{
              backgroundImage: `url('${heroBackground}')`
            }}
          />
          <div className='case-study-page__header__body col-10 maxw-large mx-auto relative'>
            <div className='maxw-text'>
              <h1 className='case-study-page__title bauta white mb1'>
                {heroTitle}
              </h1>
              {headLine && (
                <div className='case-study-page__header__headline white mb2'>
                  {headLine}
                </div>
              )}
              {subHeadLine && (
                <div className='case-study-page__header__sub-header-line text-para mb2 '>
                  {subHeadLine}
                </div>
              )}
              {link &&
                pageTitle && (
                  <SocialShareButtons
                    url={link}
                    text={pageTitle}
                    analyticsExtra='CaseStudyPageHeader'
                    networks={['facebook', 'twitter', 'linkedin', 'email']}
                  />
                )}
            </div>
          </div>
        </header>

        <section className='mx-auto col-10 maxw-large case-study-page__details-section relative overflow-hidden'>
          {metaContent && (
            <CaseStudyMetaContents
              metaContents={metaContent}
              defaultMaxShowing={
                this.props.greaterThanLg ? metaContent.length : 1
              }
              extraClass={classnames('col col-12 lg-col-5', {
                pr4: this.props.greaterThanLg
              })}
            />
          )}
          <div
            className='col col-12 lg-col-7 case-study-page__content'
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </section>
      </main>
    )
  }
}

function mapStateToProps ({ browser, wpData: { caseStudyPosts }, location }) {
  // in wp, and in our routes, there is no trailing slash,
  // however some browsers add that, so we need to align here by removing
  // note: might not be a problem in prod..
  const pathname = (location.pathname || '').replace(/\/$/, '')
  const pageData =
    find(caseStudyPosts, ({ link }) => {
      return getNormalisedPathname(link) === pathname
    }) || generatePageDataFromPathname(pathname)
  return {
    data: pageData,
    greaterThanLg: browser.greaterThan.lg
  }
}

export default connect(mapStateToProps, { requestWpCaseStudyPostDataSuccess })(
  CaseStudyPage
)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/CaseStudyPage.js